<template>
    <searchContainer :searchHandler="search" :resetHandler="reset">
        <template v-slot:items>
            <div class="row">
                <input-number v-model="filters.id" :options="{ id: 'id', label: 'id' }"/>
                <input-text v-model="filters.name" :options="{ id: 'name', label: 'name' }"/>
                <select-supplier-types v-model="filters.type" :options="{ id: 'type', label: 'type', placeholder: 'placeholders.all' }"/>
                <select-supplier-fleets v-model="filters.fleet" :options="{ id: 'fleet', label: 'fleet', placeholder: 'placeholders.all', params: { withNotSet: true } }"/>
            </div>
        </template>
    </searchContainer>
</template>
<script>

    import {mapGetters} from "vuex";
    import {CRUD_SEARCH_RESET} from "actions/crud";
    import searchContainer from "@/components/crud/card/CardSearch";

    const CRUD_CODE = "suppliers";
    export default {
        name: "SupplierSearch",
        components: {
            searchContainer
        },
        props: {
            listHandler: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                transPrefix: CRUD_CODE,
                filters: {
                    id: this.getFilterByKey('id'),
                    name: this.getFilterByKey('name'),
                    type: this.getFilterByKey('type'),
                    fleet: this.getFilterByKey('fleet'),
                },
                filtersMap: {
                    id: 'id',
                    name: 'name',
                    type: 'type',
                    fleet: 'fleet',
                },
            }
        },
        mounted() {
            this.setSearchParams(this.filters, this.filtersMap);
        },
        computed: {
            ...mapGetters([
                "getSearchFilters"
            ])
        },
        methods: {
            search() {
                this.resetPagination();
                this.setSearchParams(this.filters, this.filtersMap, {routeParams: this.getFilters(this.filters)});
                this.pushRoute(this.getSearchFilters);
                this.listHandler();
            },
            reset() {
                this.resetPagination();
                this.$store.dispatch(CRUD_SEARCH_RESET);
                this.filters = this.clearFilters(this.filters);
                this.pushRoute();
                this.listHandler();
            },
            resetPagination() {
                //Reset Pagination
                this.$emit('input', 0);
            },
            pushRoute(query = {}) {
                this.$router.push({name: this.$route.name, query}).catch(() => {});
            },
            canSelectCountry() {
                return true;
            },
            canNotSelectCountry() {
                return !this.canSelectCountry();
            },
            canSelectCity() {
                return this.filters.country_id;
            },
            canNotSelectCity() {
                return !this.canSelectCity();
            },
        }
    };
</script>
